module.exports = __webpack_public_path__ + "media/images/hakone/hankyu_hakone_th02-b4c35b2321b76c1cad8e7dcf92d1d3ad.jpg";